import { defineMessages } from 'react-intl'

/* eslint-disable max-len */
export default defineMessages({
  heroTitle: 'User experience at the workplace',
  name: 'Business Case',
  heroDescription: 'We optimize work processes! To do this, we visit your production halls/warehouses/or offices and use targeted interview techniques to find out what the work processes of the various employees and their departments look like. In this way, we determine where there is potential for process optimization. In the next step, we analyse your system landscape and check which tools can be set up to improve the user experience, shorten work processes and increase productivity.'
})
